/**
 * Shared helpers for deriving display names from profile / auth sources.
 */

/**
 * Returns the first whitespace-delimited token of `name`. Empty / non-string
 * inputs become empty strings so callers can use the result directly in a
 * conditional.
 */
export function getFirstName(name: string | null | undefined): string {
  if (!name) return '';
  const trimmed = name.trim();
  if (!trimmed) return '';
  const firstToken = trimmed.split(/\s+/)[0];
  return firstToken ?? '';
}

/**
 * Pulls the most descriptive name out of a Supabase auth user's metadata.
 * Different OAuth providers populate different keys (Google uses `full_name`,
 * others use `name`), so we try both.
 */
export function getAuthFullName(metadata: Record<string, unknown> | null | undefined): string {
  if (!metadata) return '';
  const candidates = [metadata.full_name, metadata.name];
  for (const value of candidates) {
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return '';
}
